import $ from 'jquery';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import service from '../../services/allservices.jsx';
import '../../stylesheet/faqs.css';
import { getClientId, getClientSecret, buildClientHeader } from "../../utils/clientAuth.js";
// const mapStateToProps = state =>
// ({
//     publicKey: state.publicKey.publicKey,
//     keyRecieved: state.publicKey.keyRecieved,
//     cardState: state.getCardReducer.cardState,
//     display: state.getCardReducer.display
// })

// const mapDispatchToProps = dispatch =>
// ({
//     fetchCard(state) {
//         dispatch(
//             actions.getCardAction(state)
//         )
//     },
//     fetchPublicKey(keyRecieved) {
//         dispatch(
//             actions.publicKeyAction(keyRecieved)
//         )
//     },
// })


class TermsDigiWallet extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loader: true,
            TnC: [],
        }
    }

    componentDidMount() {
        // let plink = process.env.REACT_APP_ADMINSERVICE_URL
        // let plink =  process.env.REACT_APP_ADMINSERVICE_URL
        let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
        let appid = localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex'
        // console.log("Link " + plink + service.TCDigWallet + appid )
        let traceId = getClientId();
        let gid = getClientId();
        fetch(plink + service.TCDigWallet + "/" + appid, {
            headers: new Headers({
                'Content-Type': 'application/json',
                'clientId': gid,
                'clientSecret': getClientSecret(gid, appid),
                'X-Trace-Id': traceId,
                'X-KlickEx-Client': buildClientHeader(),
            }),
        })
            .then(response => {
                if (response.status === 200) {
                    let message = response.headers.get('message');
                    response.json().then(json => {

                        this.setState({
                            TnC: json
                        })
                        toast.success(message), {
                            position: 'top-right',
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 60
                        }
                    })
                }
                else if (response.status === 422) {
                    toast.error(response.headers.get('message'), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 60
                    })
                }
                else if (response.status === 401) {
                    if (this.props.history !== undefined) { this.props.history.push('/SessionOut') }
                } else {

                }
            })
    }

    render() {
        const { TnC } = this.state

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable
                    pauseOnHover
                />
                <div className="col-sm-12 ">
                    <div className="row" style={{}}>

                        <div className="col-sm-12">

                            <div className="col-sm-12 p-0" style={{ background: "#fff" }}>
                                <div className="row">
                                    <div className="col-sm-12 ">

                                        {TnC && TnC.termsList && TnC.termsList.map((value, Index) =>
                                            <div className="col-sm-12 pb-5">
                                                <div className="upload-content">
                                                    <div dangerouslySetInnerHTML={{ __html: value }} />
                                                </div>
                                            </div>
                                        )

                                        }

                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default TermsDigiWallet;


// WEBPACK FOOTER //
// ./src/components/termsandcondition/TermsDigiWallet.jsx